import api from './api';

/**
 * Cria uma nova chamada no painel para o paciente.
 * @param {Object} payload { CODAGENDA, CODMEDICO, CODPAC, NOMEPAC, SALA }
 */
export async function createCall(payload) {
  const response = await api.post('/calls', payload);
  return response?.data || null;
}

/**
 * Atualiza o status de uma chamada ativa (ex: 'arrived', 'done', 'expired').
 * @param {string|number} id ID da chamada
 * @param {string} status Novo status
 */
export async function updateCallStatus(id, status) {
  if (!id) return null;
  const response = await api.patch(`/calls/${id}`, { status });
  return response?.data || { success: true };
}

/**
 * Rechama o paciente no painel (incrementa contagem / toca alerta sonoro).
 * @param {string|number} id ID da chamada
 */
export async function recallCall(id) {
  if (!id) return null;
  const response = await api.post(`/calls/${id}/recall`);
  return response?.data || { success: true };
}

/**
 * Cancela o atendimento no painel (incrementa contagem / toca alerta sonoro).
 * @param {string|number} id ID da chamada
 */
export async function cancelCall(id) {
  if (!id) return null;
  const response = await api.post(`/calls/${id}/cancel`);
  return response?.data || { success: true };
}

/**
 * Retorna as chamadas ativas em exibição no painel da TV.
 */
export async function getActiveCalls() {
  const { data } = await api.get('/calls/active');
  return Array.isArray(data) ? data : [];
}

/**
 * Busca todas as chamadas realizadas por um médico em uma determinada data.
 * @param {number|string} codMedico Código do médico (CODMEDICO)
 * @param {string|Date} date Data no formato YYYY-MM-DD ou objeto Date
 */
export async function getTodayCallsByDoctor(codMedico, date) {
  if (!codMedico || !date) {
    return [];
  }

  // Normaliza a data caso venha como objeto Date do JavaScript
  const formattedDate = date instanceof Date ? date.toISOString().split('T')[0] : String(date);

  const { data } = await api.get('/calls/today', {
    params: {
      CODMEDICO: codMedico,
      date: formattedDate,
    },
  });

  return Array.isArray(data) ? data : [];
}

/**
 * Busca o histórico de eventos de uma chamada pelo ID da chamada ou pelo CODAGENDA.
 * @param {string|number} identifier Call ID ou CODAGENDA
 */
export async function getCallHistory(identifier) {
  if (!identifier) {
    return [];
  }

  const { data } = await api.get(`/calls/${identifier}/history`);
  return Array.isArray(data) ? data : [];
}
